<template>
  <div class="extension page" ref="page">
    <app-bar v-if="$route.query.hasAppBar != 0" class="f-s-16" color="#333" background="#FFF" nomenu backNative>
      <div slot="title">邀请好友</div>
    </app-bar>
    <div class="headBg">
      <img src="https://img.youchent.com/public/1/head_bg3_v1.png" style="width: 100%;" alt="">
      <div :class="['rule-btn', $route.query.hasAppBar !=0 ? '' :'no-appbar']" @click="$common.routerPush('/activity_rule_v1')">
      </div>
      <div class="head-cont">
        <!-- <div class="bg-tit1">
          <img src="../assets/img/zql/extension_new/dot-l.png" alt="">
          <span>邀请好友</span>
          <img src="../assets/img/zql/extension_new/dot-r.png" alt="">
        </div> -->
        <!-- <div class="bg-box">
          <div>
            <img src="../assets/img/zql/extension_new/bg_box.png" alt="">
            <section class="l-award">
              <div class="t-1">最高奖</div>
              <div class="t-2 font-san">
                18
              </div>
              <span class="t-3">元</span>
            </section>
          </div>
          <img src="../assets/img/zql/extension_new/add.png" alt="">
          <div>
            <img src="../assets/img/zql/extension_new/bg_box.png" alt="">
            <div class="mult-award-t">多重大奖</div>
          </div>
        </div> -->
        <div class="invite-btn" @click="toShare">
          <img src="../assets/img/zql/btn_invite.png" />
          <!-- <img src="../assets/img/zql/extension_new/invite_btn.png" alt="">
          <div class="btn-txt" @click="toShare">
            <span>立即邀请</span>
            <img src="../assets/img/zql/extension_new/white_trangle.png" alt="">
          </div> -->
        </div>
      </div>
    </div>
    <div class="page-content">

      <img src="../assets/img/zql/icon_redenvelope@2x.png" alt="" class="redenvelope" @click="clickRedbagImg">
      <div v-if="isViewRecSuccess" class="rec_redenvelope_pop">
        <div class="inner-wrap">
          <img class="pop-img" v-if="isGetedBonusRedbag && userRegRewardDto.rewardAmount" src="../assets/img/zql/rec_redenvelope2.png" >
          <img class="pop-img" v-else src="../assets/img/zql/rec_redenvelope.png" >
          <img class="close-img" src="../assets/img/zql/white_cir_close.png" @click="isViewRecSuccess=false;">
          
          <div class="btn-place" @click="clickPopBtn"></div>
          <div v-if="isGetedBonusRedbag && userRegRewardDto.rewardAmount" class="txt-wrap">
            <p class="money">{{ userRegRewardDto.rewardAmount }}<span>元</span></p>
            <p class="lse">邀请好友注册奖励</p>
          </div>
          <div v-else class="txt-wrap">
            <p class="lse-top">邀请好友注册最高得</p>
            <p class="money">9.9<span>元</span></p>
          </div>
        </div>
      </div>
      

      <div class="activity-item" style="margin-top: -60px;padding: 24px 10px 24px 10px;">
        <div class="btn-title" style="margin-bottom: 18px;">
          邀请7重奖励
        </div>
        <ul class="all-catalog">
          <li>
            <div class="red-dot-idx">
              1
            </div>
            <div class="money-desc" style="text-align:left;">
              注册奖：绑定微信最高奖 <span>9.9元/人</span>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
              2
            </div>
            <div class="money-desc flex1 d-flex justify-space-between align-item-center" >
              <div>
                拜师奖：有效徒弟最高奖<span>14元/人</span>
              </div>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
             3
            </div>
            <div class="money-desc">
              阶梯奖：有效徒弟阶梯奖<span>12306元/期</span>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
              4
            </div>
            <div class="money-desc">
              长期贡献奖：永久做单分红奖最高徒弟<span>8%</span>，
              徒孙<span>2%</span>，永久悬赏主发单分红奖徒弟<span>5%</span>，
              徒孙<span>2%</span>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
              5
            </div>
            <div class="money-desc">
              出师奖：<span>10元/人</span>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
              6
            </div>
            <div class="money-desc">
              超级榜单奖：榜单第一名奖<span>12888元/期</span>
            </div>
          </li>
          <li>
            <div class="red-dot-idx">
              7
            </div>
            <div class="money-desc">
              达人奖：额外补贴最高<span>6元/人</span>
            </div>
          </li>
        </ul>
        <div style="color:#FF691E;font-size:12px;margin-top: 18px;text-align: left;">
          以上奖励详情请查看下面每个奖项具体说明，严禁使用任何作弊等违规手段参与活动，一经发现永久封号。追究违规者责任，并收回所有活动奖励及违规所得。
        </div>
      </div>

      <div class="activity-item" >
        <div class="btn-title" style="font-weight:bold;">
          我的奖励
        </div>
        <div class="invite-num-list d-flex justify-space-between" style="margin: 0 -6px;">

          <div class="list-item">
            <div class="num c-black-3">
              <span class="f-s-18 f-bold">{{friendsData.friends ? friendsData.friends : 0}}</span>
              <span class="f-s-12">人</span>
              </div>
            <div class="list-item-title f-s-14 c-black-9">提现徒弟数</div>
          </div>
          <!-- <div class="list-item">
            <div class="num c-black-3">
              <span class="f-s-18 f-bold">{{friendsData.friends ? friendsData.friends : 0}}</span>
              <span class="f-s-12">人</span>
            </div>
            <div class="list-item-title f-s-14 c-black-9">徒孙数</div>
          </div> -->
          <div class="list-item">
            <div class="num c-black-3">
              <span class="f-s-18 f-bold">{{friendsData.taskCount ? friendsData.taskCount : 0}}</span>
              <span class="f-s-12">个</span>
            </div>
            <div class="list-item-title f-s-14 c-black-9">任务数</div>
          </div>
          
          <div class="list-item">
            <div class="num f-s-16 c-black-3">
              <span class="f-s-13">¥</span>
              <span class="f-s-18 f-bold">{{friendsData.reward ? friendsData.reward / 100 : 0}}</span>
            </div>
            <div class="list-item-title f-s-14 c-black-9">累计奖励</div>
          </div>
        </div>
        <div class="btn-block d-flex justify-center align-item-center">

          <div class="curperiod-btn active-btn" @click="$common.routerPush('/current_period_v1')">
            <span>查看本期奖励</span>
            <!-- <img src="../assets/img/zql/extension_new/right_enter.png" alt=""> -->
          </div>
          <!-- <button @click="$common.routerPush({path: '/linkInvitations', query: {appId: $route.query.appId}})">链接邀请</button>
          <button @click="$common.routerPush({path: '/qrInvitation', query: {appId: $route.query.appId}})">我的邀请码</button>
          <button @click="$common.routerPush('/myFriend')">我的好友</button> -->
        </div>

        <div style="font-size: 12px;color: #ff6234;margin-top: 12px;">若邀请二维码打不开，请重新保存二维码分享给好友</div>

      </div>


      <div class="activity-item">
        <div class="btn-title" style="font-weight:bold;">
          奖励1·注册奖
        </div>

        <p style="font-size:14px;margin-bottom: 10px;color:#999;">邀请好友注册最高<span style="font-size:20px;color:#FF691E;font-weight:bold;">9.9元</span>/人</p>
        
        <div v-if="isGetedBonusRedbag" class="invite-num-list d-flex justify-space-between" style="margin: 0 -6px;">
          <div class="list-item">
            <div class="num c-black-3">
              <span class="f-s-18 f-bold">{{userRegRewardDto.rewardAmount ? userRegRewardDto.rewardAmount : 0}}</span>
              <span class="f-s-12">元</span>
              </div>
            <div class="list-item-title f-s-14 c-black-9">待领取奖励</div>
          </div>
          <div class="list-item">
            <div class="num c-black-3">
              <span class="f-s-18 f-bold">{{userRegRewardDto.regPersons ? userRegRewardDto.regPersons : 0}}</span>
              <span class="f-s-12">个</span>
            </div>
            <div class="list-item-title f-s-14 c-black-9">注册人数</div>
          </div>
        </div>
        <div v-else class="d-flex items-center" style="padding-left: 3px;">
          <img src="../assets/img/zql/logo.png" 
            style="width:52px;height:52px;border-radius:52px;margin-right:8px;"
          />
          <div class="d-flex" style="flex-direction: column;justify-content: space-evenly;">
            <p style="font-size:15px;font-weight:600;">邀请{{userRegRewardDto.minPersons}}名提现好友即可解锁注册奖励</p>
            <p style="font-size:13px;color:#999999;text-align:left;">邀请进度：{{userRegRewardDto.usedPerson}}/ {{userRegRewardDto.minPersons}}</p>
          </div>
        </div>

        <div class="btn-block d-flex justify-center align-item-center">
          <div :class="['curperiod-btn', userRegRewardDto.rewardAmount ? 'active-btn':'active-btn']" @click="clickRecTxtBtn">
            <span>{{ isGetedBonusRedbag && userRegRewardDto.rewardAmount ? '领取奖励' : '立即邀请' }}</span>
          </div>
        </div>

        <div style="font-size: 12px;color: #ff6234;margin-top: 12px;padding:0 12px;">邀请好友绑定实名微信（领取新人红包）即可享受注册奖励，好友做单越多，奖励越高</div>
      </div>

      <div class="activity-item" style="padding: 24px 14px 24px 10px;">
        <div class="btn-title" style="margin-bottom: 18px;">
          奖励2·拜师奖
        </div>
        <ul class="friend-money-list">
          <li>
            <div class="money-amount">
              <span class="f-s-12 f-bold">¥</span>
              <span class="f-s-18 f-bold">6</span>
            </div>
            <div class="money-desc" style="text-align:left;">
              徒弟首次提现<span>奖2元</span>，第2到5次提现奖
              <span>1元/次</span>。
            </div>
          </li>
          <li>
            <div class="money-amount">
              <span class="f-s-12 f-bold">¥</span>
              <span class="f-s-18 f-bold">5</span>
            </div>
            <div class="money-desc flex1 d-flex justify-space-between align-item-center" >
              <div>
                徒弟首次开通发单会员<span>奖5元</span>
              </div>
              <!-- <span style="color: #FE6B1D;font-size: 13px;" @click="isVisibleSample=true">查看样图</span> -->
            </div>
          </li>
          <li>
            <div class="money-amount">
              <span class="f-s-12 f-bold">¥</span>
              <span class="f-s-18 f-bold">1</span>
            </div>
            <div class="money-desc">
              徒孙首次提现<span>奖1元</span>
            </div>
          </li>
          <li>
            <div class="money-amount">
              <span class="f-s-12 f-bold">¥</span>
              <span class="f-s-18 f-bold">2</span>
            </div>
            <div class="money-desc">
              徒孙首次开通发单会员<span>奖2元</span>
            </div>
          </li>
        </ul>
        
      </div>
      
      <!-- <div class="activity-item">
        <div class="btn-title" style="width:200px;">
          奖励2·任务分成奖
        </div>
        <div class="link-s-title d-flex justify-center align-item-center">
          <span class="f-s-13 c-black-3">我的推广等级：{{level}}</span>
        </div>
        <div class="tg-grid service-long">
          <div class="grid-head">
            推广等级
          </div>
          <div class="grid-head">
            等级条件
          </div>
          <div class="grid-head">
            收益分红
          </div>
          <div class="grid-singular">
            普通推广员
          </div>
          <div class="grid-singular">
            徒弟数：1
          </div>
          <div class="grid-singular">
            徒弟：4%
          </div>
          <div class="grid-even">
            银牌推广员
          </div>
          <div class="grid-even">
            徒弟数：50
          </div>
          <div class="grid-even">
            徒弟：6%
          </div>
          <div class="grid-singular">
            金牌推广员
          </div>
          <div class="grid-singular">
            <div>徒弟数：100</div>
            <div>任务数：1000</div>
          </div>
          <div class="grid-singular">
            <div>徒弟：6%</div>
            <div>徒孙：2%</div>
          </div>
          <div class="grid-even">
            钻石推广员
          </div>
          <div class="grid-even">
            <div>徒弟数：500</div>
            <div>任务数：10000</div>
          </div>
          <div class="grid-even">
            <div>徒弟：8%</div>
            <div>徒孙：2%</div>
          </div>
        </div>
        <div class="f-s-12 c-black-9 t-left">根据徒弟做单活跃奖励，持续做单持续奖励</div>
      </div> -->

      <div class="activity-item">
        <div class="btn-title" style="width: 200px;">
          奖励3·阶梯奖
        </div>
        <div class="img-title d-flex align-item-center justify-center f-s-12">
          本期徒弟提现人数阶梯奖，最高奖励<span class="f-s-12" style="color:#FE6B1D;margin: 0;">{{stepTotalAmount}}元</span>
        </div>
        <ul class="ladder-award">
          <li v-for="(item, index) in ladderData" :key="index">
            <div class="money-amount">
              <span class="f-s-12 f-bold money-flag">¥</span>
              <span class="f-s-15 f-bold">{{item.money}}</span>
              <span class="f-s-12 f-bold small-money" v-if="item.smallMoney">{{item.smallMoney}}</span>
            </div>
            <div class="award-cont">
              <section class="cont-left">
                <div class="f-s-16 t-left">徒弟首次提现{{item.persons}}人</div>
                <div class="f-s-12 c-black-9 t-left">已完成：{{item.cmpPresons}}/{{item.persons}}</div>
              </section>
              <div class="cont-r-btn" :class="item.status == 2? 'a-received' : item.status == 1 ? 'a-done': '' " 
                @click="stepClick(item)"
              >
                {{item.status == 2 ? '已领奖' : item.status == 1 ? '去领奖': '去邀请'}}
              </div>
            </div>
          </li>
        </ul>
      </div>  

       <div class="activity-item">
        <div class="btn-title" style="width:200px;">
          奖励4·长期贡献奖
        </div>
        <p style="font-size:14px;">我的推广等级：{{userRegRewardDto.gradeName}}</p>
        <p style="font-size:12px;color:#999999;">徒弟做单活跃奖励，持续做单持续奖励</p>
        <div class="tg-grid service-long">
          <div class="grid-head">
            推广等级
          </div>
          <div class="grid-head">
            等级条件
          </div>
          <div class="grid-head">
            收益分红
          </div>
          <div class="grid-singular">
            普通推广员
          </div>
          <div class="grid-singular">
            徒弟数：1
          </div>
          <div class="grid-singular">
            徒弟：4%
          </div>
          <div class="grid-even">
            银牌推广员
          </div>
          <div class="grid-even">
            徒弟数：50
          </div>
          <div class="grid-even">
            徒弟：6%
          </div>
          <div class="grid-singular">
            金牌推广员
          </div>
          <div class="grid-singular">
            <div>徒弟数：100</div>
            <div>任务数：1000</div>
          </div>
          <div class="grid-singular">
            <div>徒弟：6%</div>
            <div>徒孙：2%</div>
          </div>
          <div class="grid-even">
            钻石推广员
          </div>
          <div class="grid-even">
            <div>徒弟数：500</div>
            <div>任务数：10000</div>
          </div>
          <div class="grid-even">
            <div>徒弟：8%</div>
            <div>徒孙：2%</div>
          </div>
        </div>

        <div class="tg-grid longer">
          <div class="grid-head">
            奖励类型
          </div>
          <div class="grid-head longer" style="text-align: left;padding-left: 22px;">
            发单分红
          </div>
          <div class="grid-singular">
            购买会员
          </div>
          <div class="grid-singular longer" style="text-align: left;padding-left: 22px;">
            徒弟：5%，徒孙：2%
          </div>
          <div class="grid-even">
            购买置顶
          </div>
          <div class="grid-even longer" style="text-align: left;padding-left: 22px;">
            徒弟：5%，徒孙：2%
          </div>
          <div class="grid-singular">
            购买刷新
          </div>
          <div class="grid-singular longer" style="text-align: left;padding-left: 22px;">
            徒弟：5%，徒孙：2%
          </div>
          <div class="grid-even">
            购买推荐
          </div>
          <div class="grid-even longer" style="text-align: left;padding-left: 22px;">
            徒弟：5%，徒孙：2%
          </div>
        </div>

        <!-- <div class="f-s-12 c-black-9 t-left">此奖励为发单人购买会员、置顶、刷新、推荐永久 分红。</div> -->
      </div>

      <!-- <div class="activity-item">
        <div class="btn-title" style="width: 200px;">
          奖励5·新人福利阶梯奖
        </div>
        <div class="img-title d-flex align-item-center justify-center f-s-12">
          本期新人福利阶梯奖，最高奖励<span class="f-s-12" style="color:#FE6B1D;margin: 0;">{{newStepTotalAmount}}元</span>
        </div>
        <ul class="ladder-award">
          <li v-for="(item, index) in rewardNewList" :key="index">
            <div class="money-amount">
              <span class="f-s-12 f-bold money-flag">¥</span>
              <span class="f-s-15 f-bold">{{item.money}}</span>
              <span class="f-s-12 f-bold small-money" v-if="item.smallMoney">{{item.smallMoney}}</span>
            </div>
            <div class="award-cont">
              <section class="cont-left">
                <div class="f-s-16 t-left">徒弟完成新人福利{{item.persons}}人</div>
                <div class="f-s-12 c-black-9 t-left">已完成：{{item.cmpPresons}}/{{item.persons}}</div>
              </section>
              <div class="cont-r-btn" :class="item.status == 2? 'a-received' : item.status == 1 ? 'a-done': '' " 
                @click="stepClick(item, true)"
              >
                {{item.status == 2 ? '已领奖' : item.status == 1 ? '领奖': '去完成'}}
              </div>
            </div>
          </li>
        </ul>
      </div> -->

      <!-- <div class="activity-item" style="padding: 24px 14px 24px 24px;">
        <div class="btn-title" style="margin-bottom: 18px;width: 200px;">
          奖励6·推广达人奖
        </div>
        <ul class="daren-desc-list">
          <li>
            <div class="no-x">
              <span>1</span>
            </div>
            <div class="money-desc">
              可申请注册奖励，奖励更丰厚
            </div>
          </li>
          <li>
            <div class="no-x">
              <span >2</span>
            </div>
            <div class="money-desc flex1 d-flex justify-space-between align-item-center" >
              <div>
                可申请独立推广链接
              </div>
            </div>
          </li>
          <li>
            <div class="no-x">
              <span>3</span>
            </div>
            <div class="money-desc">
              可申请独立实时后台
            </div>
          </li>
        </ul>
        <p class="f-s-12" style="color:#999999;margin-top:15px;">申请条件：30天内推广50个有效徒弟后即可申请</p>
        <p class="f-s-12" style="color:#999999;">请添加微信号申请：WX1523819428
          <span @click="copy('WX1523819428')" class="copy" style="color: #333;text-decoration: underline;">复制</span>
        </p>
      </div> -->

      <div class="activity-item">
        <div class="btn-title" style="width: 200px;">
          奖励5·出师奖
        </div>
        <div style="font-size:14px;text-align: left;padding: 0 8px 4px;">
          奖励规则：<span style="color:#999999;">
          徒弟从注册开始完成100单以上，做单金额100元以上，师傅奖励10元，每个徒弟只奖励1次。
          </span>
        </div>
        <div style="font-size:14px;text-align: left;padding: 0px 8px 0;">
          奖励范围：<span style="color:#999999;">
          从2024年5月1日以后邀请的徒弟才算。
          </span>
        </div>
      </div>

      <div class="activity-item" style="padding: 15px 20px;">
        <div class="btn-title" style="width:200px;">
          <div class="d-flex justify-center align-item-center">
            <span>奖励6·超级榜单奖</span>
          </div>
          <div class="btn-list" >
            <div class="btn-list-item"></div>
          </div>
        </div>
        <div style="font-size: 14px;text-align: left;margin-bottom: 12px;">
          推广超级榜单奖，第一名奖<span style="color:#FF691E;">12888</span>元，奖励本期前<span style="color:#FF691E;">500名</span>。
        </div>
        <section class="self-info">
          <div class="d-flex align-item-center">
            <img src="../assets/img/zql/logo.png" alt="" class="avatar">
            <div>
              <p class="f-s-15 c-black-3">我的排名：
                <span v-if="superListInfo.indexNo > -1">{{superListInfo.indexNo}}</span>
                <span v-else>
                  还差{{superListInfo.spanPersons}}名上榜
                </span>
              </p>
              <p class="f-s-13 c-black-9" style="margin:0;text-align:left;">本期徒弟人数：{{superListInfo.persons}}</p>
            </div>
          </div>
          <div class="d-flex align-item-center justify-center">
            <div class="curperiod-btn active-btn f-s-13" style="width:200px"  
              @click="toSuperList"
            >
              <span>查看榜单</span>
            </div>
          </div>
        </section>
      </div> 

      <div class="activity-item">
        <div class="btn-title" style="width: 200px;">
          奖励7·达人奖
        </div>
        <div style="font-size:14px;text-align: left;padding: 0 8px 4px;">
          推广达人可申请额外补贴奖励，按每期有效徒弟数计算，徒弟越多奖励越高，最高可达<span style="color:#FF691E;">6元/人</span>（100人起）。
          有实力的请加V：zhongbang988。
        </div>
        <div class="d-flex align-item-center justify-center">
          <div class="curperiod-btn active-btn f-s-13" style="width:200px"  
            @click="copy('zhongbang988')"
          >
            <span>复制微信</span>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="to-rules">活动<br>规则</div> -->
    <awardDia v-if="isViewAwardDia" 
      v-model="isViewAwardDia" 
      :is-new-step-award="isNewStepAward"
      :cur-data="curData" 
      @receiveSuccess="receiveSuccess"></awardDia>

    <div class="preview-img" v-if="isVisibleSample" @click="clickImgMask">
      <img class="cont-img" 
        src="https://img.youchent.com/np/npexample.png"  
        @touchstart="touchImgStart"
        @touchend="touchImgEnd"
      />
      <!-- <img class="close-btn" src="../assets/img/icon_close.png"  @click="clickImgMask"> -->
    </div>

    <div v-if="shareImg" class="gary-block-full d-flex align-item-center justify-center" style="z-index:1009;" @click="shareImg = false">
      <div style="width:100%;">
        <div class="gary-bth" style="font-size: 14px;background: #fff;line-height: 40px;" @click="saveToLocal">
          保存图片
        </div>
        <div class="gary-bth" style="font-size: 14px;background: #fff;line-height: 40px;" @click.stop="shareImg = false">
          关闭
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appBar from '../components/appBar'
import awardDia from '../components/awardDia'

// import Cookies from 'js-cookie'

export default {
  name: 'extensionNewV1',
  components: {
    appBar,
    awardDia
  },
  computed: {
    isGetedBonusRedbag() {
      let { openreg } = this.userRegRewardDto
      if (openreg) {
        return true; // 已解锁
      }
      return false;
    }
  },
  data() {
    return {
      isViewRecSuccess: false,
      isVisibleSample: false,
      isViewAwardDia: false,
      isNewStepAward: false,
      friendsData: {},
      rewardNewList: [],
      newStepTotalAmount: 0,
      friendsList: [
        // {
        //   bonsAmount: 70000,
        //   friends: 2000,
        //   alias: '浆糊。slso',
        // },
        // {
        //   bonsAmount: 1300,
        //   friends: 200,
        //   alias: '浆糊。slso',
        // }
      ],
      level: '',
      activity: 0,
      stepTotalAmount: 0,
      // info: {},
      rankImgList: [
        require('../assets/img/zql/extension_new/num_1.png'),
        require('../assets/img/zql/extension_new/num_2.png'),
        require('../assets/img/zql/extension_new/num_3.png')
      ],
      superListInfo: {
        curAcId: 0 , // 当前活动Id
        persons: 0, // 徒弟人数
        spanPersons: 0, // 距离上个人数
        lastAcId: 0, // 上期Id 不存在就是-1
        indexNo: -1, // 当前排名 -1未上榜
        inviteAcdetails: [] // 排行榜
      },
      ladderData: [],
      curData: {},
      touchTime: 0,
      touchInterval: null,
      shareImg: false,
      userRegRewardDto: {
        openreg: 0, // 是否包含注册奖励(0 显示待解锁)
        status: 0, // 0 未领奖 1领奖 (是否已领取)
        avgAmount: 0, // 平均奖励
        minPersons: 0, // 最少邀请人数
        regPersons: 0, // 注册人数
        usedPerson: 0, // 做了任务并且已提现的好友人数
        rewardAmount: 0 // 待领取奖励
      },
    }
  },
  watch: {
    touchTime() {
      if (this.touchInterval != null && this.touchTime > 1200) {
        clearInterval(this.touchInterval)
        this.touchTime = 0
      }
    },
  },
  methods: {
    clickRedbagImg() {
      this.isViewRecSuccess = true;
    },
    clickRecTxtBtn() {
      this.isViewRecSuccess = true;
    },
    clickPopBtn() {
      if (this.isGetedBonusRedbag) {
        if (this.userRegRewardDto.rewardAmount) {
          this.receiveBagEv(); // 领取红包
        } else {
          this.toShare();
        }
      } else {
        this.toShare();
      }
    },
    // 超级榜单数据
    getSuperList() {
      this.$axios.post('/user/activity2/getDetailList', {
        id: -1
      }).then(res => {
        if(res.code == 200) {
          let result = res.data || {};
          // if (result.inviteAcdetails) {
          //   result.inviteAcdetails.forEach(per => {
          //     let alias = per.alias;
          //     if (alias.length> 1) {
          //       per.alias = alias.substr(0,1) + '****' + alias.substr(alias.length-1)
          //     } else {
          //       per.alias = alias + '****'
          //     }
          //   })
          // }
          this.superListInfo = result
        }
      })
    },
    receiveBagEv() {
      if (!this.userRegRewardDto.id) {
        this.$bhUi.Toast({text:'获取奖励失败，请返回重试'})
        return;
      }
      this.$axios.post('/user/activity/regBons', {
        id: this.userRegRewardDto.id
      }).then(res => {
        if (res.code == 200) {
          this.$bhUi.Toast({text:'奖励领取成功'})
          this.isViewRecSuccess = false
          this.getRegRedbagInfo();
        }
      })
    },
    copy(text) {
      let oTextarea = document.createElement('textarea')
      oTextarea.value = text
      document.body.appendChild(oTextarea)
      oTextarea.select()
      document.execCommand("Copy")
      oTextarea.className = 'oTextarea'
      oTextarea.style.display='none'
      oTextarea.parentNode.removeChild(oTextarea)
      this.$bhUi.Toast({text:'已复制到剪贴板'})
    },
    // friendsSum() {
    //   this.$axios.post('/user/grade/friendsSum', {
    //     month: 1,
    //     status: 1,
    //     userId: Cookies.get('id')
    //   })
    //   .then(res => {
    //     if (res.code == 200) {
    //       this.friendsData = res.data
    //     }
    //   }) 
    // },
    stepClick(item, isNew) {
      if (item.status == 2) {
        return;
      }
      if (item.status == 1) {
        if (isNew) {
          this.isNewStepAward = true;
        } else {
          this.isNewStepAward = false;
        }
        // 显示领奖弹层
        this.curData = item;
        this.isViewAwardDia = true;
      } else {
        // 去分享
        this.toShare()
      }
    },
    receiveSuccess() {
      console.log('eeeeeeeeeeeeeee', this.curData.status);
      this.ladderData
      this.curData.status = 2;
      this.isViewAwardDia = false;
    },
    toShare() {
      this.isViewRecSuccess = false;
      this.$common.routerPush({path: '/tabInvitations', query: {appId: this.$route.query.appId}})
    },
    toSuperList() {
      this.$common.routerPush({path: '/superAwardList', query: {appId: this.$route.query.appId}})
    },
    // friends() {
    //   this.$axios.get('/sys/week/friends', {})
    //   .then(res => {
    //     if (res.code == 200) {
    //       this.friendsList = res.data
    //     }
    //   })
    // },
    lastFriends() {
      this.$axios.get('/sys/week/lastFriends', {})
      .then(res => {
        if (res.code == 200) {
          // this.friendsList = res.data
        }
      })
    },
    grade() {
      this.$axios.get('/user/grade/info', {})
      .then(res => {
        if (res.code == 200) {
          this.friendsData = {
            taskCount: res.data.tasks,
            friends: res.data.friends,
            reward: res.data.amout
          }
          res.data.userGrades.forEach(item => {
            if (res.data.level == item.level) {
              this.level = item.levelName
            }
          })
        }
      })
    },
    // 查询完成新人福利阶梯奖励
    getRewardNewLvList() {
      this.$axios.post('/user/activity2/queryNewLevelList', {
        id: -1
      }).then(res => {
        if (res.code == 200) {
          let rewardNewList = res.data || []
          let newStepTotalAmount = 0;
          rewardNewList.forEach((per, idx) => {
            let money = per.reward / 100;
            newStepTotalAmount += money;
            if (money >= 1000) {
              money = String(money); 
              per.money = money.substr(0,1);
              per.smallMoney = money.substr(1);
            } else {
              per.money = money;
            }
            if (idx == 1) {
              //   per.status = 2;
              console.log('second');
            }
          })
          this.newStepTotalAmount = newStepTotalAmount;
          this.rewardNewList = rewardNewList;
        }
      })
    },
    // 领取新人福利奖励
    receiveRewardNew(item) {
      this.$axios.post('/user/activity2/rewardNewLevel', {
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          item.status = 2;
        }
      })
    },
    // 获取阶梯列表
    getStepList() {
      this.$axios.post('/user/activity2/queryLevelList', {
        id: -1
      })
      .then(res => {
        if(res.code == 200) {
          let ladderData = res.data || []
          let stepTotalAmount = 0;
          ladderData.forEach(per => {
            let money = per.reward / 100;
            stepTotalAmount += money;
            if (money >= 1000) {
              money = String(money); 
              per.money = money.substr(0,1);
              per.smallMoney = money.substr(1);
            } else {
              per.money = money;
            }
          })
          this.stepTotalAmount = stepTotalAmount;
          this.ladderData = ladderData
        }
      })
    },
    
    // getCur() {
    //   this.$axios.get('/user/activity/getCur', {
    //     userId:'',
    //     id: this.activity
    //   })
    //   .then(res => {
    //     if(res.code == 200) {
    //       this.info = res.data
    //     }
    //   })
    // },

    getActivityList() {
      return this.$axios.get('/user/activity/list')
      .then(res => {
        if (res.code == 200) {
          this.activityList = res.data
          res.data.forEach(item => {
            if (item.status == 1) {
              this.activity = item.id
            }
          })
        }
      })
    },
    clickImg() {
    },
    touchImgStart() {
      this.touchInterval = setInterval(() => {
        if (this.touchTime >= 600) {
          this.touchTime = 0
          clearInterval(this.touchInterval)
          this.shareImg = true
        } else {
          this.touchTime += 100
        }
      }, 100)
    },
    touchImgEnd() {
      this.touchTime = 0
      clearInterval(this.touchInterval)
    },
    clickImgMask() {
      this.isVisibleSample = false;
    },
    saveToLocal() {
      let url = 'https://img.youchent.com/np/npexample.png';
      let postMessage = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.saveImg && window.webkit.messageHandlers.saveImg.postMessage;
      if (window.native && window.native.saveImg) {
        window.native.saveImg(url)
      } else if (postMessage) {
        window.webkit.messageHandlers.saveImg.postMessage(url)
      } else {
        this.$bhUi.Toast({text:'暂不支持，请截图保存', zIndex: 1999})
      }
    },
    getRegRedbagInfo() {
      this.$axios.get('/user/activity2/getUserDetail').then(res => {
        if (res.code == 200 && res.data) {
          let { userRegRewardDto, openreg = 0, gradeName, status = 0, usedPerson = 0 } = res.data;

          if (userRegRewardDto && userRegRewardDto.rewardAmount) {
            userRegRewardDto.rewardAmount = (userRegRewardDto.rewardAmount / 100).toFixed(2); 
          }

          this.userRegRewardDto = Object.assign({
            gradeName,
            openreg,
            status,
            usedPerson
          }, userRegRewardDto)
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log('离开前', this.$route.meta.keepAlive, to, this.$refs.page.scrollTop);
    if (['tabInvitations', 'activityRuleV1', 'currentPeriodV1', 'superAwardList'].includes(to.name)) {
      sessionStorage.setItem('extensionScrollTop', this.$refs.page.scrollTop)
    } else {
      sessionStorage.setItem('extensionScrollTop', 0)
    }
    setTimeout(() => {
      next()
    }, 300)
  },
  created() {
    if (this.$route.query.appId) {
      this.$axios.defaults.headers.common['appId'] = this.$route.query.appId
    }
    this.getRegRedbagInfo()
    // this.friendsSum()
    this.getSuperList();
    this.getRewardNewLvList();
    this.getStepList();
    this.grade()
    // this.getActivityList().then(res => {
      // this.getInfo()
      // this.getCur()
    // })
  },
  activated() {
    let sctop = sessionStorage.getItem('extensionScrollTop')
    if (sctop) {
      setTimeout(()=>{
        this.$refs.page.scrollTop = sctop
      }, 100)
      sessionStorage.setItem('extensionScrollTop', 0)
    }
  }
}
</script>

<style lang="less" scoped>
.page{
  height: 100%;
  background:linear-gradient(0deg,rgba(255,99,27,1) 0%,rgba(254,107,29,1) 68%,rgba(255,97,52,1) 84%,rgba(254,163,14,1) 100%);
  font-size: 0;
  overflow: auto;
  position: relative;
  .headBg{
    width: 100%;
    position: relative;
    z-index: 0;

    .rule-btn {
      position: absolute;
      top: 70px;
      right: 0;
      width: 82px;
      height: 30px;

      &.no-appbar {
        top: 22px;
      }

      line-height: 32px;
      text-align: center;
      font-size: 14px;
      color: #F8F2E5;

      background-image: url(../assets/img/zql/extension_new/rule-btn2.png);
      background-size: 100% 100%;
    }
    .head-cont {
      position: absolute;
      // bottom: 16%;
      bottom: 21%;
      width:100%;

      .bg-tit1 {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 18px;
          margin: 0 12px;
          color: #FF6234;
        }
        img {
          height: 12px;
        }
      }

      .bg-box {
        display: flex;
        align-items: center;
        width: 100vw;
        justify-content: center;
        margin-bottom: 18%;

        >div {
          position: relative;
          width: 33%;

          img {
            width: 100%;
          }

          .l-award {
            position: absolute;
            width: 100%;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            color: #FF6234;
            top: 20%;

            .t-1{
              font-size: 10px;
              width: 12px;
              line-height: 16px;
            }
            .t-2{
              font-size: 60px;
              line-height: 48px;
              font-weight: bold;
              font-family: mySanFrancisco;
              margin: 0 3px;
            }
            .t-3 {
              font-size: 15px;
              line-height: 17px;
            }
          }

          .mult-award-t {
            font-weight: bold;
            font-size: 20px;
            color: #FF6234;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
          }
        }
        >img {
          width: 28px;
          height: 28px;
          margin: 0 15px;
        }
      }

      .invite-btn {
        position: relative;
        width: 200px;
        height: 51px;
        margin: 0 auto;

        img {
          position: absolute;
          width:100%;
          left: 0;
          right: 0;
          margin: 0 auto;
          webkit-animation:  weather-icon-move 1.2s ease-in-out infinite;
          animation: weather-icon-move 1.2s ease-in-out infinite;
        }
        .btn-txt{
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            color: #fff;
            font-size: 15px;
            line-height: 15px;
          }
          img {
            width: 11px;
            height: 12px;
            margin-left: 5px;
          }
        }
      }
    }
  }
  .page-content{
    // background:linear-gradient(0deg,rgba(255,99,27,1) 0%,rgba(254,107,29,1) 68%,rgba(255,97,52,1) 84%,rgba(254,163,14,1) 100%);
    background: #FE6B1D;
    padding-bottom: 58px;
    >div{
      position: relative;
      // top: -60px;
    }
    .activity-item{
      &.more-z-index{
        z-index: 2;
      }

      .daren-desc-list {
        list-style: none;
        padding: 0;

        li {
          display: flex;
          margin-top: 16px;
          align-items: center;
          background: #F8F7F7;
          height: 45px;
          border-radius: 12px;
          text-align: center;
          width: 275px;
          margin: 0 auto;
          padding-left: 20px;
          margin-top: 8px;
          &:first-child {
            margin-top: 0;
          }

          .no-x {
            width: 20px;
            height: 20px;
            background: linear-gradient(180deg, #FFC84A 0%, #FE6C1E 100%);
            border-radius: 50%;
            color: #fff;
            font-size: 14px;
            margin-right: 8px;
          }
          .money-desc {
            font-size: 16px;
            span {
              color: #FE6B1D;
            }
          }
        }
      }

      .all-catalog {
        list-style: none;
        padding: 0;
        

        li {
          display: flex;
          margin-top: 16px;
          align-items: flex-start;
          text-align: left;

          .red-dot-idx {
            margin-right: 10px;
            width: 18px;
            min-width: 18px;
            height: 18px;
            background: linear-gradient(0deg, #F60F00 0%, #F59606 100%);
            border-radius: 50%;
            color: #fff;
            font-size: 12px;
            margin-top: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .money-desc {
            font-size: 14px;
            span {
              color: #FE6B1D;
            }
          }
        }
      }

      .friend-money-list {
        list-style: none;
        padding: 0;

        li {
          display: flex;
          margin-top: 16px;
          align-items: center;

          .money-amount {
            width: 39px;
            min-width: 39px;
            height: 39px;
            margin-right: 10px;
            background-image: url(../assets/img/zql/extension_new/lab-ico.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            .money-flag {
              margin-top: 2px;
              transform: scale(0.8);
            }
            .small-money {
              margin-top: 2px;
            }
          }
          .money-desc {
            font-size: 14px;
            span {
              color: #FE6B1D;
            }
          }
        }
      }

      .ladder-award {
        list-style: none;
        padding: 0;

        li {
          display: flex;
          margin-top: 23px;
          margin-bottom: 23px;
          align-items: center;

          .money-amount {
            width: 39px;
            height: 39px;
            margin-right: 10px;
            background-image: url(../assets/img/zql/extension_new/lab-ico.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            .money-flag {
              margin-top: 2px;
              transform: scale(0.8);
            }
            .small-money {
              margin-top: 2px;
            }
          }
          .award-cont {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .cont-left {

            }
            .cont-r-btn {
              width: 74px;
              height: 31px;
              line-height: 31px;
              background: linear-gradient(90deg, #FE6B1D 1%, #FFC94B 100%);
              box-shadow: 0px 4px 10px 0px rgb(255 201 75 / 56%);
              border-radius: 31px;
              font-size: 14px;
              color: #fff;

              &.a-received {
                background: #C2C2C2;
              }
            }
          }
        }
      }

      .img-title{
        span{
          margin: 4px 8px 0;
          font-size: 12px;
        }
      }
      .main-img{
        display: block;
        width: 100%;
        margin: 7px;
        margin-top: -10px;
      }
      .invite-num-list{
        margin: 6px 0 20px;
        .list-item{
          flex-grow: 1;
          position: relative;
          // &::after{
          //   content:' ';
          //   position: absolute;
          //   right: 0px;
          //   top: 50%;
          //   width: 1px;
          //   height: 17px;
          //   background-color: #DBDBDB;
          //   // transition: tr;
          //   transform: translateY(-50%);
          // }
          // &:last-child::after{
          //   content: '';
          //   display: none;
          // }
        }
      }
      .link-s-title{
        img{
          margin: -4px 6px 0;
        }
      }
      .tg-list{
        .tg-list-item{
          margin-top: 17px;
          border:1px solid rgba(255,106,30,1);
          overflow: hidden;
          border-radius:6px;
          .tg-item-head{
            height: 44px;
            padding: 0 12px;
            background:linear-gradient(0deg,rgba(254,170,0,1) 0%,rgba(255,210,6,1) 100%);
          }
          .tg-item-body{
            padding: 15px;
            >div{
              color: #FF6A1F;
              margin-bottom: 10px;
              .i{
                margin-right: 4px;
              }
              &:last-child{
                margin-bottom: 0;
              }
            }
          }
        }
      }
      .tg-grid{
        display: grid;
        grid-template-areas: 'a a a';
        grid-gap: 1px 1px;
        // align-items: center;
        align-content: center;
        margin-top: 20px;
        margin-bottom: 15px;
        font-size: 14px;
        background-color: #FF691E;
        border: #FF691E 2px solid;
        border-radius: 6px;
        overflow: hidden;
        &.longer{
          grid-template-areas: 'a a';
        }

        &.service-long {
          >div {
            text-align: left;
            padding-left: 12px;
          }
        }
        >div{
          // height: 100%;
          padding: 10px 0px;
          display: flex;
          flex-direction: column;
          // justify-content: center;
        }
        .grid-head{
          background: linear-gradient(0deg, #FEAA00 0%, #FFD105 100%);
          color: #fff;
          // background:linear-gradient(0deg,rgba(254,170,0,1) 0%,rgba(255,209,5,1) 100%);
        }
        .grid-singular{
          color: #333;
          background:#fff;
        }
        .grid-even{
          color: #333;
          background: #fff;
        }
      }
      .self-info {
        box-shadow: 0px 6px 21px 0px #ffe7da;
        padding: 15px 15px 22px;
        margin-bottom: 20px;
        border-radius: 8px;

        .avatar {
          width:52px;
          height:52px;
          margin-right:12px;
          border-radius: 52px;
        }
      }
    
      .link-img-block{
        position: absolute;
        left: 18px;
        right: 18px;
        bottom: 0px;
        transform: translateY(65%);
        // z-index: 2;
        img{
          width: 26px;
        }
      }
    }
    
    .redenvelope {
      position: fixed;
      bottom: 80px;
      right: 20px;
      width: 66px;
      z-index: 100;
      // animation: float-move 3s ease-in-out infinite;
      webkit-animation:  weather-icon-move 1.6s ease-in-out infinite;
      animation: weather-icon-move 1.6s ease-in-out infinite;
    }

    .rec_redenvelope_pop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.4);
      overflow: hidden;
      z-index: 999;
      padding: 20px;

      .inner-wrap {
        position: relative;
        width: 100%;
        .pop-img {
          width: 100%;
        }

        .close-img {
          position: absolute;
          left: 0;
          right: 0;
          bottom: -20px;
          width: 26px;
          margin: 0 auto;
          z-index: 3;
        }
        .btn-place {
          position: absolute;
          bottom: 17%;
          left: 0;
          right: 0;
          margin: 0 auto;
          width: 60%;
          height: 46px;
          z-index: 23;
        }

        .txt-wrap {
          position: absolute;
          right: 0;
          left: 0;
          top: 50%;
          margin-top: -27%;
          color: #FC3C42;
          font-size: 14px;

          .lse-top {
            font-size: 18px;
            color: #FC3C42;
            margin-bottom: 8px;
            letter-spacing: 1px;
          }

          .money {
            font-size: 48px;
            line-height: 1;
            height: 48px;
            font-weight: bold;
            span {
              font-size: 24px;
            }
          }
          .lse {
            font-size: 12px;
            margin-top: 6px;
          }
        }
      }

      
    }

    .curperiod-btn {
      height: 37px;
      width: 200px;
      margin-top: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333333;
      border: 1px solid #333333;
      border-radius: 40px;

      &.active-btn{
        background: linear-gradient(90deg, #FE6B1D 1%, #FFC94B 100%);
        box-shadow: 0px 4px 10px 0px rgba(255,201,75,0.56);
        border: none;
        color: #fff;
      }
      
      &.grey-btn {
        background: #C2C2C2;
        color:#fff;
        border: 0;;
      }

      span {
        font-size: 16px;
      }
      img {
        height: 10px;
        width: 10px;
        margin-left:10px;
      }
    }
  }
  .to-rules{
    position: absolute;
    top: 50px;
    right: 12px;
    padding: 8px 12px 12px;
    line-height: 1.3;
    border-radius: 0 0 100px 100px;
    color: #FFF;
    font-size: 14px;
    background-color: #FEB509;
  }

  .activity-item {
    padding: 15px 10px 15px;
    .btn-title {
      font-weight: bold;
    }
  } 

  .preview-img {
    position: fixed;
    width: 100vw;
    height: 100vh;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    top: 0;
    left: 0;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;

    .cont-img {
      width: 90vw;
    }
    .close-btn {
      position: fixed;
      width: 30px;
      height: 30px;
      bottom: 50px;

      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }
}
@-webkit-keyframes weather-icon-move {
  50% {
    -webkit-transform: scale(1.06);
            transform: scale(1.06);
  }
}
@keyframes weather-icon-move {
  50% {
    -webkit-transform: scale(1.06);
            transform: scale(1.06);
  }
}

@-webkit-keyframes float-move {
  50% {
    -webkit-transform: scale(1.06);
            transform: scale(1.06);
  }
}
@keyframes float-move{
  from {transform: translateY(0) }
  50%{ transform: translateY(-15px) }
  to{ transform: translateY(0) }
}
</style>
